import {twMerge} from '@sdox/utils'

import type {PropsWithChildren} from 'react'

export interface ContentProps extends PropsWithChildren {
  className?: string
}

export const Content = ({className, children}: ContentProps) => (
  <div
    className={twMerge(
      'sdox-scrollbar min-h-0 overflow-y-auto',
      className,
    )}
  >
    {children}
  </div>
)
